import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loadingcomponent from '../loader/loadingcomponent';
import MessageModal from '../common/bottom-modal-message';
import {
  getGlobalSettingValue,
  getItemOfSessionStorage,
} from '../../services/common/utils';
import {
  setAuthModalContent,
  setClicked2FAData,
  setShowAuthModal,
  setShowEnableMediumAuthBtn,
  setShowGetKuwaitAppBtn,
} from '../../reducer/utilitySlice';
import { IS_2FA_DONE } from '../../services/common/Constants';
import {GTMScreenView} from "../../../src/analytics/GoogleTagManager";
import {CT_Events} from "../../../src/analytics/CTEvents";
import ExclusiveModal from "../../components/common/exclusive-modal";

const XpressProfitBalance = ({ pmsitem }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [deeplinktext, setDeeplinktext] = useState("");
  const navigate = useNavigate();
  const [showInfoMessage, setShowInfoMessage] = useState(false);
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  const {CT_ScreenView} = CT_Events();
  const {
    utilityData: { globalSetting },
  } = useSelector((state) => state);

  const settingsArr = globalSetting
        ? globalSetting?.Globalsettings[0]?.items[0]?.metadata
        : [];

  const { data: { data } = {}, isLoading } = useQuery(
    [pmsitem?.uniqueid, pmsitem?.method, JSON.parse(pmsitem?.sourceid), {}],
    {
      retry: false,
      retryOnMount: false,
    }
  );

  const toggleShowInfoMessage = () => {
    setShowInfoMessage(!showInfoMessage);
  };

  const toggleModal = () => {
    setShow(!show);
  };

  const handleLoadBalance = () => {
       navigate('/load-balance');
  };

  const handleTransferBalance = () => {
    // navigate('/transfer-balance', {
    //   state: {
    //     amount: data?.response?.price,
    //   },
    // });
    try{
      setShow(true);
      setDeeplinktext(getGlobalSettingValue('exclusivexpressprofit_deeplink_web', settingsArr),);
      return false;
    }catch{}
  };

  useEffect(()=>{
    try{
      GTMScreenView("xpress-profit-balance", msisdn, logintype)
    }catch{}
    try{
      CT_ScreenView()
    }catch{}
  }, [])
  const handle2FA = () => {
    // if 2fa is done
    if (getItemOfSessionStorage(IS_2FA_DONE) === 'true') {
      handleTransferBalance();

      // if 2fa is pending
    } else {
      dispatch(setShowEnableMediumAuthBtn(false));
      dispatch(setShowGetKuwaitAppBtn(false));

      const requiredRedirectData = {
        url: '/transfer-balance',
        state: {
          amount: data?.response?.price,
        },
      };
      dispatch(setClicked2FAData(requiredRedirectData));
      dispatch(setShowAuthModal(true));

      dispatch(
        setAuthModalContent({
          icon: getGlobalSettingValue('beforeverificationicon_web', settingsArr),
          title: getGlobalSettingValue('beforeverificationtitle', settingsArr),
          message: getGlobalSettingValue('beforeverificationmsg', settingsArr),
          btnText: getGlobalSettingValue(
            'beforeverificationbuttontext',
            settingsArr
          ),
        })
      );
    }
  };

  if (isLoading) {
    return <Loadingcomponent />;
  }

  return (
    <>
      <div
        // className="background_grey"
        style={{ backgroundColor: data?.bgcolor ? data?.bgcolor : '#F8F8F8' }}
      >
        <div className="pt-5 pb-4 text-center sec_top">
          <div className="pse_lg">
            <div className="balance_section_info">
              <label className="me-2 dir-ltrl">{t('xps_pft_balance')}</label>
              <img
                src={process.env.PUBLIC_URL + '/assets/images/help_sm.svg'}
                alt=""
                title=""
                className="mb-1"
                onClick={() => setShowInfoMessage(true)}
              />
              <h3 className="balance">
                {data?.response?.currency} {data?.response?.price}
              </h3>
              {data?.response?.expirydate && (
                <p>
                  {t('expireson')} {data?.response?.expirydate}
                </p>
              )}
            </div>
            <div className="flex_grp_align_center mt-5">
              <button
                className="custom_btn custom_btn_primary btn_block me-2 "
                onClick={handleLoadBalance}
              >
                {data?.response?.btn_load_text}
              </button>

              <button
                className="custom_btn custom_btn_primary_outline btn_block"
                disabled={!data?.response?.isenabletransferbalance}
                onClick={handle2FA}
              >
                {data?.response?.btn_transferbalance_text}
              </button>
            </div>
          </div>
        </div>
      </div>

      <MessageModal
        type="1"
        show={showInfoMessage}
        toggleModal={toggleShowInfoMessage}
        title={data?.response?.helptitle}
        message={data?.response?.helpdesc}
      />

         <ExclusiveModal
            show={show}
            toggleModal={toggleModal}
            deeplinktext={deeplinktext}
          />
    </>
  );
};

export default XpressProfitBalance;
